import { render, staticRenderFns } from "./FormRO05.vue?vue&type=template&id=18c9f108"
import script from "./FormRO05.vue?vue&type=script&lang=js"
export * from "./FormRO05.vue?vue&type=script&lang=js"
import style0 from "./FormRO05.vue?vue&type=style&index=0&id=18c9f108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports